import { ofType } from 'redux-observable';
import { map, switchMap } from 'rxjs/operators';
import JobProApi from '../../dependencies/JobProApi';

const EQUPIMENT_FIELDS = 'id,color,displayOrder,name, officeRef(id,name)';

// Action types
const FETCH_EQUPIPMENTS = 'FETCH_EQUPIPMENTS';
const FETCH_EQUPIPMENTS_COMPLETE = 'FETCH_EQUPIPMENTS_COMPLETE';

const DEFAULT_STATE = {
  equipment: [],
  loading: false
};

// Reducer
export default function equipments (state = DEFAULT_STATE, { payload, type }) {
  switch (type) {
    case FETCH_EQUPIPMENTS:
      return  DEFAULT_STATE;
    case FETCH_EQUPIPMENTS_COMPLETE:
      return { 
        ...state,       
        ...payload,
        loading: false
      }
    default:
      return state;
  }
}

// Action creators
export const fetchEquipments = () => ({
  type: FETCH_EQUPIPMENTS
});

const fetchEquipmentsComplete = (equipment) => (
    {
  type: FETCH_EQUPIPMENTS_COMPLETE,
  payload: { equipment }
}

);

// Epics
export const fetchEquipmentsEpic = (action$) => action$.pipe(
  ofType(FETCH_EQUPIPMENTS),
  switchMap(() =>   
  {
    
    const criteria = {
        schedulable: true
    };
    return JobProApi.equipment.query(
        criteria,{    
    fields: EQUPIMENT_FIELDS
  })}),
  map(fetchEquipmentsComplete)
);


// Selectors
export * from './selector';